<template>
    <div class="card card-blue">
        <div class="card-header">
            <div class="row">
                <div class="col-md-6">
                    <h4 class="m-b-0"><i class="fas fa-file-signature"></i> Contract Overview</h4>
                </div>
                <div class="col-md-6 text-right" v-if="contract.status === 'DRAFT'">
                    <div class="button-group">
                        <a class="btn btn-success waves-effect waves-light" data-target="#contractOverview"
                           data-toggle="modal" href="javasript:void(0);">
                            <i class="fas fa-edit"></i> Edit
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-lg-6">
                    <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right">
                            <dt v-if="contract.type === 'SALE'">Seller</dt>
                            <dt v-if="contract.type === 'PURCHASE'">Buyer</dt>
                        </div>
                        <div class="col-sm-8 text-sm-left">
                            <dd class="mb-1"><a href="">{{contract.owner.biz_name}}</a></dd>
                        </div>
                    </dl>
                    <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right">
                            <dt v-if="contract.type === 'PURCHASE'">Seller</dt>
                            <dt v-if="contract.type === 'SALE'">Buyer</dt>
                        </div>
                        <div class="col-sm-8 text-sm-left">
                            <dd class="mb-1"><a href="">{{contract.counterparty.biz_name}}</a></dd>
                        </div>
                    </dl>
                </div>
                <div class="col-lg-6">
                    <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right">
                            <dt>Created</dt>
                        </div>
                        <div class="col-sm-8 text-sm-left">
                            <dd class="mb-1">{{contract.created_at | date}}</dd>
                        </div>
                    </dl>
                    <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right">
                            <dt>Expiry Date</dt>
                        </div>
                        <div class="col-sm-8 text-sm-left">
                            <dd class="mb-1">{{contract.expires_at | date}}</dd>
                        </div>
                    </dl>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-6" id="cluster_info">
                    <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right">
                            <dt>Contract Type</dt>
                        </div>
                        <div class="col-sm-8 text-sm-left">
                            <dd class="mb-1">{{contract.type | capitalize}}</dd>
                        </div>
                    </dl>
                </div>
                <div class="col-lg-6" id="provenance_info">
                    <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right">
                            <dt>Provenance</dt>
                        </div>
                        <div class="col-sm-8 text-sm-left">
                            <dd class="mb-1">
                                <a :href="contract.provenance" target="_blank" v-if="contract.provenance">{{
                                    contract.provenance }}</a>
                                <span v-else>NA</span>
                            </dd>
                        </div>
                    </dl>
                </div>
            </div>
        </div>


        <div aria-labelledby="contractOverview" class="modal fade" id="contractOverview" role="dialog" tabindex="-1">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-body card-blue">
                        <div class="card-body">
                            <h4 class="card-title">Contract Overview</h4>
                            <h5 class="card-subtitle">Overview of contract type, parties, products, prices</h5>
                            <!-- Tab panes -->
                            <div class="tab-content">
                                <div class="tab-pane active" id="properties" role="tabpanel">
                                    <div class="row m-t-20">
                                        <div class="col-md-12">
                                            <form>
                                                <div class="col-sm-12 col-lg-12 m-t-20">
                                                    <div class="form-group row">
                                                        <label class="col-sm-2 text-right control-label col-form-label"
                                                               v-if="contract.type === 'PURCHASE'">Buyer</label>
                                                        <label class="col-sm-2 text-right control-label col-form-label"
                                                               v-if="contract.type === 'SALE'">Seller</label>
                                                        <div class="col-sm-8">
                                                            <p class="form-control" readonly style="height: 42px">
                                                                {{contract.owner.biz_name}}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-lg-12 m-t-20">
                                                    <div class="form-group row">
                                                        <label class="col-sm-2 text-right control-label col-form-label"
                                                               v-if="contract.type === 'SALE'">Buyer</label>
                                                        <label class="col-sm-2 text-right control-label col-form-label"
                                                               v-if="contract.type === 'PURCHASE'">Seller</label>
                                                        <div class="col-sm-8">
                                                            <multiselect
                                                                    :class="{'is-invalid': submitted && errors.has('partner')}"
                                                                    :clear-on-select="false"
                                                                    :close-on-select="true"
                                                                    :hide-selected="true"
                                                                    :internal-search="false"
                                                                    :limit="3"
                                                                    :loading="isLoading"
                                                                    :max-height="600"
                                                                    :options="partners"
                                                                    :options-limit="300"
                                                                    :searchable="true"
                                                                    :show-no-results="false"
                                                                    @search-change="searchPartners"
                                                                    class="form-control"
                                                                    data-vv-as="partner"
                                                                    id="partner"
                                                                    label="partner"
                                                                    name="partner"
                                                                    open-direction="up"
                                                                    placeholder="Search Partners"
                                                                    track-by="id"
                                                                    v-model="editContract.counterparty"
                                                                    v-validate="'required'">
                                                                <template slot="singleLabel" slot-scope="props">
                                                                    <div class="option__desc">
                                                                        <div class="option__desc">
                                                                            {{ props.option.biz_name }}
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                                <template slot="option" slot-scope="props">
                                                                    <div class="option__desc">
                                                                        <div class="option__desc" v-if="props.option">
                                                                            <h5>{{ props.option.biz_name }}</h5>
                                                                            <h6>{{ props.option.line1}}</h6>
                                                                            <h6>{{ props.option.city+', '+
                                                                                props.option.country}}</h6>
                                                                        </div>
                                                                        <div class="option__desc" v-else>
                                                                            <h5>Add New</h5>
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                                <template slot="afterList">
                                                                    <div class="col-xs-12">
                                                                        <router-link :to="{name: 'addbuyer' , params: {expressid: 1}}"
                                                                                     class="btn btn-block btn-lg btn-outline-success"
                                                                                     v-if="contract.type === 'SALE'">
                                                                            <i class="fa fa-plus-circle"></i>&nbsp;Add
                                                                            Buyer
                                                                        </router-link>
                                                                        <router-link :to="{name: 'addseller' , params: {expressid: 1}}"
                                                                                     class="btn btn-block btn-lg btn-outline-success"
                                                                                     v-if="contract.type === 'PURCHASE'">
                                                                            <i class="fa fa-plus-circle"></i>&nbsp;Add
                                                                            Seller
                                                                        </router-link>
                                                                    </div>
                                                                </template>
                                                            </multiselect>
                                                            <div class="invalid-feedback"
                                                                 v-if="submitted && errors.has('partner')">{{
                                                                errors.first('partner') }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-lg-12 m-t-20">
                                                    <div class="form-group row">
                                                        <label class="col-sm-2 text-right control-label col-form-label">Creation
                                                            Date</label>
                                                        <div class="col-sm-8">
                                                            <p class="form-control" readonly style="height: 42px">
                                                                {{contract.created_at | date}}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-lg-12 m-t-20">
                                                    <div class="form-group row">
                                                        <label class="text-right col-sm-2 control-label col-form-label"
                                                               for="expiry_date">Expiry Date</label>
                                                        <div class="input-group col-sm-8">
                                                            <div class="input-group-prepend date">
                                                                <span class="input-group-text"><i
                                                                        class="fa fa-calendar"></i></span>
                                                            </div>
                                                            <input autocomplete="off"
                                                                   class="form-control"
                                                                   data-vv-as="expiry_date"
                                                                   id="expiry_date"
                                                                   name="expiry_date"
                                                                   placeholder="dd/mm/yyyy"
                                                                   style="height: 42px"
                                                                   type="text"
                                                                   v-model="editContract.expires_at">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-lg-12 m-t-20">
                                                    <div class="form-group row">
                                                        <label class="text-right col-sm-2 control-label col-form-label">Provenance</label>
                                                        <div class="input-group col-sm-8">
                                                            <input class="form-control"
                                                                   data-vv-as="Provenance"
                                                                   name="provenance"
                                                                   placeholder="Provenance"
                                                                   style="width: 250px; height: 42px;"
                                                                   type="text"
                                                                   v-model="editContract.provenance"
                                                                   v-validate="">
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="update" class="btn waves-effect waves-light btn-success" data-dismiss="modal"
                                type="submit">Submit
                        </button>
                        <button class="btn waves-effect waves-light btn-secondary" type="button">Reset</button>
                        <button class="btn waves-effect waves-light btn-danger" data-dismiss="modal" type="button">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import Multiselect from 'vue-multiselect';
    import UnitSelect from "../../common/UnitSelect";
    import CurrencySelect from "../../../protected/common/CurrencySelect";
    import {mapGetters} from "vuex";

    export default {
        name: "ContractOverview",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {Multiselect, UnitSelect, CurrencySelect},
        props: {
            contract: Object
        },
        data() {
            return {
                submitted: false,
                partners: [],
                isLoading: false,
                services: [],
                unit_symbol: null,
                editContract: {
                    expires_at: null,
                    future_exchange: null,
                    future_contract: null,
                    index_exchange: null,
                    index_name: null,
                },
                selectedPricingMethod: null,
                pricingMethods: [
                    {
                        id: 1,
                        name: 'Flat'
                    },
                    {
                        id: 2,
                        name: 'Future'
                    },
                    {
                        id: 3,
                        name: 'Index'
                    }
                ],
                explorer: null,
            }
        },
        mounted() {
            this.explorer = this.$EXPLORER;
            this.init();
        },
        methods: {
            async init() {
                this.editContract.id = this.contract.id;
                // this.$refs.reference1.unit = {
                //     "id": this.contract.quantity.unitId,
                //     "name": this.contract.quantity.unitName,
                //     "symbol": this.contract.quantity.unitSymbol,
                //     "base_unit": null,
                //     "created_at": null,
                //     "factor": null,
                //     "plural": null,
                //     "type": null
                // };
                this.editContract.counterparty = this.contract.counterparty;
                // this.editContract.unit = this.$refs.reference1.unit;
                this.editContract.expires_at = this.contract.expires_at ? moment(this.contract.expires_at).format("MM/DD/YYYY") : null;
                // this.editContract.goodsSerivces = {
                //     id: this.contract.goods_services.id,
                //     name: this.contract.goods_services.name
                // };
                // this.editContract.quantity = this.contract.quantity.amount;
                // this.editContract.goods_services_specs = this.contract.goods_services_specs;
                // this.editContract.pricing_terms_id = this.contract.pricing_terms.id;
                // this.editContract.pricingMethod = {
                //     name: this.capitalize(this.contract.pricing_terms.method)
                // };
                // this.$refs.reference.currency = {
                //     "id": this.contract.pricing_terms.rate.currency_id,
                //     "name": this.contract.pricing_terms.rate.currency_name,
                //     "symbol": this.contract.pricing_terms.rate.currency_symbol,
                //     "plural": null,
                //     "symbol_native": null,
                //     "decimals": null,
                //     "rounding": null,
                //     "created_at": null
                // };
                // this.editContract.currency = this.$refs.reference.currency;
                // this.editContract.rate = this.contract.pricing_terms.rate.amount;
                jQuery('#expiry_date').datepicker({
                    autoclose: true,
                    todayHighlight: true
                }).on('change', (event) => {
                    this.editContract.expires_at = event.target.value;
                });
                this.editContract.provenance = this.contract.provenance;
            },
            async getGoodsServices(searchText) {
                this.isLoading = true;
                let reply;
                if (this.contract.type === 'PURCHASE') {
                    reply = await this.$http.get("/express/" + this.currentOrg.express_id + "/purchases/goodsservices/search", {
                        params: {
                            search: searchText
                        }
                    });
                    this.services = reply.data;
                } else if (this.contract.type === 'SALE') {
                    reply = await this.$http.get("/express/" + this.currentOrg.express_id + "/sales/goodsservices/search", {
                        params: {
                            search: searchText
                        }
                    });
                    this.services = reply.data;
                }
                this.isLoading = false;
            },
            setUnit(e) {
                this.editContract.unit = e;
                this.unit_symbol = e.symbol;
            },
            addRow() {
                this.editContract.goods_services_specs.push({
                    key: null,
                    value: null
                });
            },
            removeRow(index) {
                this.editContract.goods_services_specs.splice(index, 1);
            },
            selectPricingMethod() {
                this.selectedPricingMethod = this.contract.pricingTerm.method.name;
                if (this.selectedPricingMethod === 'Flat') {
                    this.$refs.reference.currency = {
                        "id": this.contract.goodsSerivces.rate.currency_id,
                        "name": this.contract.goodsSerivces.rate.currency_name,
                        "symbol": this.contract.goodsSerivces.rate.currency_symbol,
                        "plural": null,
                        "symbol_native": null,
                        "decimals": 2,
                        "rounding": null,
                        "created_at": null
                    };
                    this.editContract.pricingTerm.currency = this.$refs.reference.currency;
                }
            },
            setCurrency(e) {
                if (e) {
                    this.editContract.currency = e;
                    this.calculateAmount();
                }
            },
            capitalize(value) {
                if (!value) return '';
                value = value.toString();
                return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
            },
            calculateAmount() {
                this.contract.total = {
                    amount: Number(this.editContract.quantity) * Number(this.editContract.rate),
                    currency_id: this.editContract.currency.id,
                    currency_name: this.editContract.currency.name,
                    currency_symbol: this.editContract.currency.symbol
                };
            },
            rateChange() {
                if (this.editContract.rate === '') {
                    this.contract.total = null;
                } else {
                    this.calculateAmount();
                }
            },
            quantityChange() {
                if (this.editContract.quantity === '') {
                    this.contract.total = null;
                } else {
                    this.calculateAmount();
                }
            },
            async update() {
                try {
                    await this.$http.post(`/express/${this.currentOrg.express_id}/contracts/${this.contract.id}/updateprops`, this.editContract);
                    this.$root.$emit('refreshContract');
                    this.$toastr('success', 'Contract updated successfully', 'Contract Updation');
                    this.$router.push({name: "viewcontract", params: {contractid: this.contract.id}});
                } catch (e) {
                    console.error(e)
                }
            },
            async searchPartners(searchText) {
                try {
                    this.isLoading = true;
                    let reply;
                    if (this.contract.type === 'PURCHASE') {
                        reply = await this.$http.get("/express/" + this.currentOrg.express_id + "/purchases/sellers/search", {
                            params: {
                                search: searchText
                            }
                        });
                    } else if (this.contract.type === 'SALE') {
                        reply = await this.$http.get("/express/" + this.currentOrg.express_id + "/sales/buyer/search", {
                            params: {
                                search: searchText
                            }
                        });
                    }
                    this.partners = reply.data;
                    this.isLoading = false;
                } catch (e) {
                    console.log(e);
                }
            }
        }
    }
</script>

<style scoped>

</style>
